// extracted by mini-css-extract-plugin
export var addButton = "_fc-0";
export var border = "_fc-8";
export var check = "_fc-h";
export var danger = "_fc-6";
export var dropdownContainer = "_fc-1";
export var editModalBody = "_fc-j";
export var footerContainer = "_fc-i";
export var fullWidth = "_fc-a";
export var hide = "_fc-9";
export var icon = "_fc-3";
export var input = "_fc-7";
export var inputFlex = "_fc-b";
export var inputWrapper = "_fc-c";
export var manualFocus = "_fc-5";
export var optionButton = "_fc-4";
export var pillWrapper = "_fc-e";
export var pointer = "_fc-2";
export var showOverflow = "_fc-f";
export var tagsFlex = "_fc-d";
export var xButton = "_fc-g";